import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaginationControlsComponent } from 'ngx-pagination';

@Component({
  selector: 'app-institucion-paginator',
  templateUrl: './institucion-paginator.component.html',
  styleUrls: ['./institucion-paginator.component.scss']
})
export class InstitucionPaginatorComponent extends PaginationControlsComponent
  implements OnInit {
  @Input()
  id!: string;
  @Input()
  maxSize!: number;
  @Output()
  pageChange!: EventEmitter<number>;
  @Output()
  pageBoundsCorrection!: EventEmitter<number>;
  constructor(public changeDetection: ChangeDetectorRef) {
    super();
  }
  ngOnInit() {

  }
}
